import { skipToken, useQuery } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth.ts';
import { CampaignApiDetails } from 'schemas/CampaignApiDetails.schema.ts';
import translateToCampaignConfig from 'services/translator.ts';
import { CampaignConfig } from 'schemas/CampaignConfig.schema.ts';
import { apiFetch } from 'utils/apiUtils';

interface IFetchSpecificCampaignVariables {
  teamId: string,
  campaignId: string,
  enabled?: boolean,
}

export default function useFetchSpecificCampaign({ teamId, campaignId, enabled = true }: IFetchSpecificCampaignVariables) {
  const { tokens } = useAuth();
  return useQuery({
    enabled: campaignId !== 'new',
    queryKey: ['campaign', { teamId, campaignId }],
    queryFn: enabled ? async (): Promise<CampaignConfig> => {
      const resultJson = await apiFetch<CampaignApiDetails>({
        path: `team/${teamId}/campaign/${campaignId}`,
        method: 'GET',
        accessToken: String(tokens.accessToken),
      });

      return translateToCampaignConfig(resultJson);
    } : skipToken,
  });
}
